export default {
  key: "auth",
  basePath: "/auth",
  exclude: false,
  components: [],
};
